export const percentToHex = (percent: number) => {
  const decimalValue = Math.round(percent * 255);
  const hexVal = decimalValue.toString(16).toUpperCase();
  if (hexVal.length === 1) {
    return `0${hexVal}`;
  }
  return hexVal;
};
